import React from 'react';

import ActionMan from '../plumbing/ActionMan';
import C from '../C';
import Misc from '../base/components/Misc';
import PropControl from '../base/components/PropControl';
import Advert from '../base/data/Advert';

/**
 * Player-variant picker for advertiser/publisher editor
 * NB: videoaspect is set per-video (one Advert could have several videos it can use)
 * NB: CTA is set in Advert - Target controls
 */
function VariantControls({ entity, path, ...other }) {
	let pvDefaultAd = ActionMan.getDataItem({type:C.TYPES.Advert, id:C.DEFAULT_AD_ID, status:C.KStatus.PUBLISHED});
	let dad = pvDefaultAd.value || {};
	// This backends onto VariantSpec.java which accepts lists
	let vpath = path.concat('variantSpec');
	// TODO support multiple styles

	let otherNoun = Advert.isa(entity) ? 'publisher' : 'advert';

	return (
		<Misc.Card title="AdUnit Variants" {...other}>
			<p>You can leave any of these settings blank. These settings will limit how ads can be served.</p>
			<p>See the <a href="https://doc.good-loop.com/dev/adunit-taxonomy.html" target="_blank">AdUnit Taxonomy</a> for more details.</p>
			
			<PropControl label="Delivery" prop="delivery" path={vpath} help="How does the Good-Loop adunit get onto the page?"
				type="select" multiple options={['vpaid', 'ourpage', 'app', 'direct', 'iframe', 'safeframe']}
			/>
			
			<PropControl label="Size" prop="size" path={vpath} help=""
				type="select" multiple options={'mpu mpu2 leaderboard billboard vbnr stickyfooter portrait square landscape fullscreen responsive'.split(' ')}
			/>
			
			<PropControl label="Play" prop="play" path={vpath} help=""
				type="select" multiple options={['onload', 'onvisible', 'onclick', 'clickthrough', 'onexpand', 'pagewrapper', 'none']}
			/>
			
			<PropControl label="After" prop="after" path={vpath} help=""
				type="select" multiple options={['vanish','persist']}
			/>

			<PropControl label="Allow video skip?" prop="skip" path={vpath}
				help={`Select neither or both and the ${otherNoun} will decide whether skipping is allowed.`}
				type="select" multiple
				options={['skippable', 'unskippable']}
				labels={['OK to show skip button', 'OK to hide skip button']}
				{...other}
			/>
			
			<PropControl label="Style" prop="style" path={vpath} type="arraytext"
				help={`A name for "How does it look & feel?" Can also cover e.g. "banner shows a video thumbnail", "use logo A/B"
We expect to define explore and discard lots of these.
We also have the custom css. We’d define a style type if (a) css isn't enough
and it has to hook into custom code, or (b) we want to report on A/B variants.`}
			/>

			<PropControl label="Custom Parameters" prop="params" path={vpath} type="keyset"
				help="A place to enable experimental features (e.g. 'no_tq'). Enter a keyword and click &quot;Add&quot;, or click the X on an existing one to remove."
			/>

			<div><small>
				Inherited spec from <a href="#advert/default-advert">default-advert</a>:
				<code>{dad.variantSpec? JSON.stringify(dad.variantSpec) : null}</code>
			</small></div>
		</Misc.Card>
	);
}

export default VariantControls;
